import { isEmpty } from "lodash";
import { RangeValue } from "@evergis/ui";

import { RootState } from "../reducers";
import { Style } from "./style";

export const getStyle = ({ style }: RootState): Style => style && style.present.style;

export const getScaleSegments = ({ style }: RootState): number[] => style && style.present.scaleSegments;

export const getDefaultScaleRange = ({ style }: RootState): RangeValue => style && style.present.defaultScaleRange;

export const getSelectedSegment = ({ style }: RootState): number => style && style.present.selectedSegment;

export const getValueIndex = ({ style }: RootState): number => style && style.present.valueIndex;

export const getStyleChilds = ({ style }: RootState): Style[] => style.present.style?.children;

export const getUndoRedo = ({ style }: RootState): { canUndo: boolean; canRedo: boolean } => ({
  canUndo: style.past.length > 1 || (style.past.length === 1 && !isEmpty(style.past[0])),
  canRedo: style.future.length > 1 || (style.future.length === 1 && !isEmpty(style.future[0])),
});

export const getHiddenLegends = ({ style }: RootState): Record<string, string[]> => style.present.hiddenLegends;
